// Health & Wellness Domain - Health, fitness, mental wellness, and lifestyle topics
export const healthWellnessData = {
  hub: {
    id: "hub_health_wellness",
    label: "Health & Wellness",
    content: "Health, fitness, mental wellness, and lifestyle topics including fitness routines and mental health management",
    visibility: "private",
    timestamp: 1703894400000,
    category: "Domain Hub",
    level: 0,
    nodeType: "hub"
  },

  clusters: [
    {
      id: "cluster_fitness_routine",
      label: "Fitness & Exercise",
      content: "Workout planning, nutrition tracking, and physical health optimization strategies",
      visibility: "private",
      timestamp: 1703851200000,
      category: "Project Cluster",
      level: 1,
      parentHub: "hub_health_wellness",
      nodeType: "cluster"
    },
    {
      id: "cluster_mental_health",
      label: "Mental Health & Mindfulness",
      content: "Stress management, therapy insights, anxiety coping strategies, and mental wellness practices",
      visibility: "ask me",
      timestamp: 1703808000000,
      category: "Project Cluster",
      level: 1,
      parentHub: "hub_health_wellness",
      nodeType: "cluster"
    }
  ],

  areas: [
    {
      id: "area_strength_training",
      label: "Strength Training",
      content: "Weightlifting programs, progressive overload principles, and injury prevention strategies",
      visibility: "private",
      timestamp: 1703846400000,
      category: "Topic Area",
      level: 2,
      parentCluster: "cluster_fitness_routine",
      parentHub: "hub_health_wellness",
      nodeType: "area"
    },
    {
      id: "area_nutrition_tracking",
      label: "Nutrition & Diet",
      content: "Macro tracking, meal planning, and nutritional strategies for body composition goals",
      visibility: "private",
      timestamp: 1703842000000,
      category: "Topic Area",
      level: 2,
      parentCluster: "cluster_fitness_routine",
      parentHub: "hub_health_wellness",
      nodeType: "area"
    },
    {
      id: "area_anxiety_management",
      label: "Anxiety & Stress",
      content: "Coping strategies, breathing techniques, identifying triggers, and stress reduction methods",
      visibility: "ask me",
      timestamp: 1703803200000,
      category: "Topic Area",
      level: 2,
      parentCluster: "cluster_mental_health",
      parentHub: "hub_health_wellness",
      nodeType: "area"
    },
    {
      id: "area_therapy_insights",
      label: "Therapy & Self-Work",
      content: "CBT techniques, therapy session insights, and personal growth work",
      visibility: "ask me",
      timestamp: 1703799600000,
      category: "Topic Area",
      level: 2,
      parentCluster: "cluster_mental_health",
      parentHub: "hub_health_wellness",
      nodeType: "area"
    }
  ],

  mementos: [
    {
      id: "memento_017",
      label: "Workout Program: 5/3/1 progression and form focus",
      content: "Me: 'I want to get stronger but I'm not sure about my programming. Should I do Starting Strength or something more advanced?' \n\nDecided on Wendler 5/3/1 after discussing goals. Current baseline: Squat 225lbs, Bench 185lbs, Deadlift 275lbs, OHP 135lbs. Goal: add 50lbs to each lift in 6 months. Key insight: focus on form over weight progression. Deload every 4th week is crucial for long-term gains. Started tracking in Strong app.",
      visibility: "private",
      timestamp: 1703841600000,
      category: "Fitness Planning",
      level: 3,
      parentArea: "area_strength_training",
      parentCluster: "cluster_fitness_routine",
      parentHub: "hub_health_wellness",
      subcategory: "Strength Training",
      nodeType: "memento"
    },
    {
      id: "memento_018",
      label: "Form Check: Deadlift technique improvement",
      content: "Me: 'My lower back is sore after deadlifts. Am I doing something wrong with my form?' \n\nDiscussed proper deadlift setup: feet hip-width, bar over mid-foot, vertical shins, neutral spine. Issue was bar drifting away from body during lift. Cues that helped: 'drag the bar up your legs' and 'squeeze oranges in armpits.' Also learned about hip hinge pattern. Back soreness gone after form corrections.",
      visibility: "private",
      timestamp: 1703837200000,
      category: "Technique Analysis",
      level: 3,
      parentArea: "area_strength_training",
      parentCluster: "cluster_fitness_routine",
      parentHub: "hub_health_wellness",
      subcategory: "Form Correction",
      nodeType: "memento"
    },
    {
      id: "memento_019",
      label: "Nutrition: Macro tracking for lean bulk",
      content: "Me: 'I want to gain muscle without getting fat. How should I set up my nutrition and track progress?' \n\nCalculated macros for lean bulk: 2800 calories (maintenance + 300), 180g protein (0.8g/lb), 350g carbs (remaining), 85g fat (0.3g/lb). Using MyFitnessPal for tracking. Target: gain 0.5lbs/week mostly muscle. Weekly weigh-ins same time/conditions. Progress photos every 2 weeks. Adjust calories based on 4-week trends.",
      visibility: "private",
      timestamp: 1703836800000,
      category: "Nutrition Planning",
      level: 3,
      parentArea: "area_nutrition_tracking",
      parentCluster: "cluster_fitness_routine",
      parentHub: "hub_health_wellness",
      subcategory: "Diet Planning",
      nodeType: "memento"
    },
    {
      id: "memento_020",
      label: "Meal Prep: Efficient weekly preparation strategy",
      content: "Me: 'I keep failing at eating healthy because I don't have time to cook during the week. Any meal prep strategies?' \n\nSetup Sunday meal prep routine: batch cook proteins (chicken, ground turkey), prep vegetables, cook grains in rice cooker. Portioned into glass containers with variety. Game-changer: prepping ingredients vs full meals allows mixing/matching. Takes 2 hours Sunday, saves 1+ hour daily. Consistency improved dramatically.",
      visibility: "private",
      timestamp: 1703832400000,
      category: "Lifestyle Optimization",
      level: 3,
      parentArea: "area_nutrition_tracking",
      parentCluster: "cluster_fitness_routine",
      parentHub: "hub_health_wellness",
      subcategory: "Meal Planning",
      nodeType: "memento"
    },
    {
      id: "memento_021",
      label: "Panic Attacks: Emergency breathing technique",
      content: "Me: 'I had a panic attack during a work meeting yesterday. I felt like I couldn't breathe and thought I might pass out. What can I do if this happens again?' \n\nLearned 4-7-8 breathing technique for acute anxiety: inhale 4 counts, hold 7, exhale 8. Also practiced 5-4-3-2-1 grounding (5 things you see, 4 you touch, 3 you hear, 2 you smell, 1 you taste). Emergency plan: excuse yourself, go somewhere private, breathe, call support person if needed. Keeps technique card in wallet.",
      visibility: "ask me",
      timestamp: 1703798400000,
      category: "Coping Strategy",
      level: 3,
      parentArea: "area_anxiety_management",
      parentCluster: "cluster_mental_health",
      parentHub: "hub_health_wellness",
      subcategory: "Anxiety Management",
      nodeType: "memento"
    },
    {
      id: "memento_022",
      label: "Anxiety Triggers: Work deadline pattern recognition",
      content: "Me: 'I notice I get really anxious before big project deadlines. Is this normal and how can I manage it better?' \n\nIdentified pattern: anxiety spikes 2-3 days before deadlines, especially when scope is unclear. Triggers: ambiguous requirements, last-minute changes, unclear expectations. Coping strategies: break projects into smaller milestones, clarify scope early, communicate blockers immediately. Also learned about anticipatory anxiety vs performance anxiety.",
      visibility: "ask me",
      timestamp: 1703794000000,
      category: "Self-Awareness",
      level: 3,
      parentArea: "area_anxiety_management",
      parentCluster: "cluster_mental_health",
      parentHub: "hub_health_wellness",
      subcategory: "Pattern Recognition",
      nodeType: "memento"
    },
    {
      id: "memento_023",
      label: "Therapy Session: Cognitive behavioral therapy techniques",
      content: "Me: 'My therapist mentioned cognitive distortions and thought challenging. Can you help me understand how to actually use these techniques?' \n\nLearned common distortions: catastrophizing, all-or-nothing thinking, mind reading. Thought challenging process: notice the thought -> identify the distortion -> ask for evidence -> create balanced thought. Example: 'I'm terrible at presentations' becomes 'I'm nervous about presentations but I've given several successful ones.' Practice: write down anxious thoughts and challenge them daily.",
      visibility: "ask me",
      timestamp: 1703793600000,
      category: "Therapy Insights",
      level: 3,
      parentArea: "area_therapy_insights",
      parentCluster: "cluster_mental_health",
      parentHub: "hub_health_wellness",
      subcategory: "CBT Techniques",
      nodeType: "memento"
    },
    {
      id: "memento_024",
      label: "Self-Compassion: Breaking perfectionist patterns",
      content: "Me: 'I'm really hard on myself when I make mistakes at work. My therapist says I lack self-compassion. How do I actually practice this?' \n\nLearned Kristin Neff's self-compassion framework: self-kindness (treat yourself like a good friend), common humanity (everyone makes mistakes), mindfulness (acknowledge feelings without judgment). Practice: when I mess up, ask 'What would I tell a friend in this situation?' Started daily self-compassion journal entries. Perfectionist voice is getting quieter.",
      visibility: "ask me",
      timestamp: 1703789200000,
      category: "Personal Growth",
      level: 3,
      parentArea: "area_therapy_insights",
      parentCluster: "cluster_mental_health",
      parentHub: "hub_health_wellness",
      subcategory: "Self-Development",
      nodeType: "memento"
    }
  ]
};
